import React, { useState } from 'react';
import './style.scss';
import logo from 'assets/imgs/logo_footer.svg';
import fb from 'assets/imgs/fb.png';
import instagram from 'assets/imgs/instagram.png';
import youtube from 'assets/imgs/youtube.png';
import headPhone from 'assets/imgs/head-phone.png';
import hotline from 'assets/imgs/hotline.png';
import mail2 from 'assets/imgs/mail2.png';
import messenger from 'assets/imgs/messenger.png';
import term from 'assets/imgs/term.png';
import certify from 'assets/imgs/certify_vnpt.png';
import { FormattedMessage, useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight } from '@fortawesome/fontawesome-free-solid';
import { Link, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Login from 'pages/Login/Login';
import { KCSModal } from 'components';

const Footer = () => {
  const [isOpenModalLogin, setOpenModalLogin] = useState(false);
  const [showPopupConfirmLogin, setShowPopupConfirmLogin] = useState(false);

  const authorized = useSelector(state => state.authorizedReducer.authorized);
  const intl = useIntl();
  const history = useHistory();

  const handleClickFeature = (url) => {
    if (!authorized) {
      setShowPopupConfirmLogin(true);
      return;
    }
    history.push(url);
  }

  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="container">
          <div className="footer__logo-wrapper">
            <img src={logo} alt="logo" className="footer__logo" />
            <a href='http://online.gov.vn/Home/AppDetails/827?AspxAutoDetectCookieSupport=1' rel="noopener noreferrer" target="_blank">
              <img src={certify} alt="certificate" className="footer__cer" />
            </a>
          </div>
          <div className="row mt-3">
            <section className="col-lg-6">
              <p>Giấy phép số: 62/GP-TTĐT do Bộ Thông tin - Truyền thông cấp ngày 09/04/2019. Tập đoàn Bưu chính Viễn thông Việt Nam</p>
              <p>
                Trụ sở: Tòa nhà VNPT, số 57 Phố Huỳnh Thúc Kháng, Phường Láng Hạ, Quận Đống Đa, Thành phố Hà Nội, Việt Nam<br />
              Mã số doanh nghiệp: 0100684378 do Sở Kế hoạch và Đầu tư TP.Hà Nội cấp ngày 22/10/2018<br />
              Giấy phép cung cấp dịch vụ viễn thông số 469/GP-BTTTT do Bộ Thông tin và Truyền thông cấp ngày 14/10/2016<br />
              Giấy phép cung cấp dịch vụ viễn thông số 18/GP-CVT do Bộ Thông tin và Truyền thông cấp ngày 18/01/2018
            </p>
            </section>

            <section className="col-lg-6">
              <div className="row footer__right">
                <div className="col-md-6 mt-4 mt-md-0">
                  <b><FormattedMessage id="IDS_TV_HELP" /></b>
                  <p className="mt-4">
                    <FontAwesomeIcon
                      color="#fff"
                      icon={faCaretRight}
                      size="lg"
                      className="mr-3"
                    />
                    <Link to="/tinh-nang/gui-yeu-cau"><FormattedMessage id="IDS_SHELPGUIYEUCAU" /></Link>
                  </p>
                  <p>
                    <FontAwesomeIcon
                      color="#fff"
                      icon={faCaretRight}
                      size="lg"
                      className="mr-3"
                    />
                    <Link to="/tinh-nang/yeu-cau-da-gui"><FormattedMessage id="IDS_SHELPYEUCAUDAGUI" /></Link>
                  </p>
                  <p>
                    <FontAwesomeIcon
                      color="#fff"
                      icon={faCaretRight}
                      size="lg"
                      className="mr-3"
                    />
                    <Link to="/tinh-nang/dia-diem-cua-hang"><FormattedMessage id="IDS_TV_DIA_DIEM_STORE" /></Link>
                  </p>
                  <p>
                    <FontAwesomeIcon
                      color="#fff"
                      icon={faCaretRight}
                      size="lg"
                      className="mr-3"
                    />
                    <a href="https://mytv.com.vn/thiet-bi-ho-tro" rel="noopener noreferrer" target="_blank">
                      <FormattedMessage id="IDS_TV_SMART_TV_SUPPORT" /></a>
                  </p>
                </div>

                <div className="col-md-6 mt-4 mt-md-0">
                  <b><FormattedMessage id="IDS_UTILITIES" /></b>
                  <p className="mt-4">
                    <FontAwesomeIcon
                      color="#fff"
                      icon={faCaretRight}
                      size="lg"
                      className="mr-3"
                    />
                    <span onClick={() => handleClickFeature('/tinh-nang/nap-tien')} className="pointer"><FormattedMessage id="IDS_TV_NAPTIEN" /></span>
                  </p>
                  <p>
                    <FontAwesomeIcon
                      color="#fff"
                      icon={faCaretRight}
                      size="lg"
                      className="mr-3"
                    />
                    <span onClick={() => handleClickFeature('/tinh-nang/mua-ma-the')} className="pointer"><FormattedMessage id="IDS_SHOMEMUATHE" /></span>
                  </p>
                  <p>
                    <FontAwesomeIcon
                      color="#fff"
                      icon={faCaretRight}
                      size="lg"
                      className="mr-3"
                    />
                    <span onClick={() => handleClickFeature('/tinh-nang/thanh-toan-dich-vu')} className="pointer"><FormattedMessage id="IDS_STHANHTOAN" /></span>
                  </p>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-md-6">
                  <b><FormattedMessage id="IDS_FOLLOW_US" /></b>
                  <div className="d-flex mt-3">
                    <img alt="icon" src={fb} />
                    <img alt="icon" className="ml-3" src={instagram} />
                    <img alt="icon" className="ml-3" src={youtube} />
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>

      <div className="footer__middle">
        <div className="footer__item">
          <a href="tel:18001166">
            <div><img alt="hotline" src={headPhone} /></div>
            <p><FormattedMessage id='IDS_APP_INTERNET_SWITCHBOARD' /><br />18001166</p>
          </a>
        </div>
        <div className="footer__item">
          <a href="tel:18001091">
            <div><img alt="hotline" src={hotline} /></div>
            <p><FormattedMessage id='IDS_APP_MOBILE_SWITCHBOARD' /><br />18001091</p>
          </a>
        </div>
        <div className="footer__item">
          <a href="mailto:cskh@vnpt.vn">
            <div><img alt="cskh" src={mail2} /></div>
            <p>cskh@vnpt.vn</p>
          </a>
        </div>
        <div className="footer__item">
          <Link to="/tinh-nang/hoi-dap">
            <div><img alt="QA" src={messenger} /></div>
            <p>Q&A</p>
          </Link>
        </div>
        <div className="footer__item">
          <Link to="/tinh-nang/dieu-khoan-su-dung">
            <div><img alt="term" src={term} /></div>
            <p><FormattedMessage id='IDS_TERM' /></p>
          </Link>
        </div>
      </div>
      <div className="footer__bottom">
        <p className="container">VNPT VinaPhone © 2020 |  <FormattedMessage id='IDS_APP_MOBILE_SWITCHBOARD' />: <a href="tel:18001091">18001091</a> | <FormattedMessage id='IDS_APP_INTERNET_SWITCHBOARD' />: <a href="tel:18001166">18001166</a></p>
      </div>

      {isOpenModalLogin &&
        <Login
          isOpenModalLogin={isOpenModalLogin}
          closeModalLogin={() => setOpenModalLogin(false)}
        />
      }
      <KCSModal
        isOpenModal={showPopupConfirmLogin}
        closeModal={() => setShowPopupConfirmLogin(false)}
        confirmButton={intl.formatMessage({ id: 'IDS_TV_SIGN_IN' })}
        confirmAction={() => { setOpenModalLogin(true); setShowPopupConfirmLogin(false) }}
        closeButton={intl.formatMessage({ id: 'IDS_VPLUS_OTP_CANCEL' })}
        content={intl.formatMessage({ id: 'IDS_SDANGNHAPTHUEBAOVNP' })}
      />
    </footer>
  );
}

export default Footer;
